import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core'
import { ActivatedRoute, RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import { AuthService } from '../../../../services/auth/auth.service'
import { getArticleIdFromRoute } from '../../../auth/util/article-purchase-route.utils'
import { ArticlePurchaseAccountShellComponent } from '../article-purchase-account-shell.component'

@Component({
  selector: 'dhp-article-purchase-continue-email',
  templateUrl: './article-purchase-continue-email.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslatePipe, ArticlePurchaseAccountShellComponent],
})
export class ArticlePurchaseContinueEmailComponent {
  private readonly route = inject(ActivatedRoute)
  private readonly authService = inject(AuthService)

  readonly articleId = computed(() => getArticleIdFromRoute(this.route))
  readonly email = computed(() => this.authService.currentUser()?.email ?? null)
}
